<script lang="ts">
  import HuggingFaceTokenPicker from '@routes/huggingface-tokens/HuggingFaceTokenPicker.svelte'

  interface HuggingFaceTokenInputValues {
    token: string | null | undefined
    tokenId: string | undefined
    saveToken: string | null | undefined
    tokenName: string
  }

  type InputValues = { [key: string]: string | undefined | null }

  interface Props {
    inputValues: InputValues
  }

  let { inputValues = $bindable() }: Props = $props()
  const huggingFaceInputValues = inputValues as InputValues & HuggingFaceTokenInputValues
</script>

<HuggingFaceTokenPicker
  bind:token={huggingFaceInputValues.token}
  bind:tokenId={() =>
    huggingFaceInputValues.tokenId ? parseInt(huggingFaceInputValues.tokenId) : undefined,
  (value) => {
    huggingFaceInputValues.tokenId = value?.toString()
  }}
  bind:saveToken={() => !!huggingFaceInputValues.saveToken,
  (value) => {
    huggingFaceInputValues.saveToken = value?.toString()
  }}
  bind:tokenName={huggingFaceInputValues.tokenName}
  customLabel="*HuggingFace token"
/>
